<template>
    <div class="gray-back" style="padding:.2rem 0 1rem 0">
        <div v-rblink="{name:'DakejianApply',query:{}}" style="padding: 10px;"> <img style="width: 100%; " src="https://cheeseman.oss-cn-hangzhou.aliyuncs.com/editor/20210308/user-0/20210308/caf9635f9db8148227664f87208f4c69.jpeg?x-oss-process=style/tb-750" /></div>
        <van-form
                  @submit="onSubmit"
                  @failed="onFailed"
        >
        <van-cell-group>
            <van-field
                    readonly
                    clickable
                    name="area"
                    :value="formData.county?formData.province+'/'+formData.city+'/'+formData.county:''"
                    input-align="right"
                    label="地区选择"
                    placeholder="点击选择省市区"
                    @click="showArea = true"
            />
            <van-popup v-model="showArea" position="bottom">
                <van-area
                        :area-list="areaList"
                        :value="formData.area"
                        @confirm="onAreaConfirm"
                        @cancel="showArea = false"
                />
            </van-popup>

            <van-field
                    v-model="formData.danwei"
                    :rules="[{ required: true, message: '学校名称不能为空' }]"
                    label="学校"
                    input-align="right"
                    error-message-align="right"
                    clearable
                    placeholder="请输入学校名称"
            />


            <van-field
                    v-model="formData.renshu"
                    :rules="[{ required: true, message: '人数不能为空' }]"
                    error-message-align="right"
                    label="参赛人数"
                    type="number"
                    input-align="right"
                    clearable
                    placeholder="请输入人数"
            />


        </van-cell-group>


        <van-divider>联系人信息</van-divider>

        <van-cell-group>

            <van-field
                    v-model="formData.name"
                    :rules="[{ required: true, message: '请输入姓名' }]"
                    error-message-align="right"
                    label="姓名"
                    input-align="right"
                    clearable
                    placeholder="请输入姓名"
            />
            <van-field
                    v-model="formData.zhiwu"
                    :rules="[{ required: true, message: '请输入校内职务' }]"
                    error-message-align="right"
                    label="校内职务"
                    input-align="right"
                    clearable
                    placeholder="请输入校内职务"
            />


            <van-field
                    v-model="formData.email"
                    :rules="[{ validator: validator.email,message:'请输入正确的邮箱'} ]"
                    error-message-align="right"
                    label="邮箱"
                    input-align="right"
                    clearable
                    placeholder="请输入邮箱"
            />


            <van-field
                    v-model="formData.phone"
                    :rules="[{ validator: validator.phone,message:'请输入正确的手机号'}]"
                    error-message-align="right"
                    label="手机"
                    input-align="right"
                    clearable
                    placeholder="请输入手机"
            />

        </van-cell-group>

        <van-divider>校长信息
        </van-divider>

        <van-cell-group>

            <van-field
                    v-model="formData.xiaozhang_name"
                    :rules="[{ required: true, message: '请输入姓名' }]"
                    error-message-align="right"
                    label="校长姓名"
                    input-align="right"
                    clearable
                    placeholder="请输入姓名"
            />


            <van-field
                    v-model="formData.xiaozhang_num"
                    :rules="[{ validator: validator.idCard,message:'请输入正确的身份证号'}]"
                    error-message-align="right"
                    label="校长身份证号"
                    input-align="right"
                    clearable
                    placeholder="请输入身份证号"
            />


        </van-cell-group>

        <van-divider>先进个人（教师或校长信息）
        </van-divider>

        <van-cell-group>

            <van-field
                    v-model="formData.jiaoshi_name"
                    :rules="[{ required: true, message: '请输入姓名' }]"
                    error-message-align="right"
                    label="校长姓名"
                    input-align="right"
                    clearable
                    placeholder="请输入姓名"
            />


            <van-field
                    v-model="formData.jiaoshi_num"
                    :rules="[{ validator: validator.idCard,message:'请输入正确的身份证号'}]"
                    error-message-align="right"
                    label="校长身份证号"
                    input-align="right"
                    clearable
                    placeholder="请输入身份证号"
            />


        </van-cell-group>

            <div style="height: 100px"></div>

        <div class="savebtn">
            <van-button
                    color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                    style="width: 3rem"
                    size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..." @click="submit">提交报名</van-button>
        </div>
        </van-form>

        <LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel" />

    </div>
</template>
<style scoped>
    .box {
        /*margin-bottom: 1.5rem;*/
    }



    .savebtn {
        position: fixed;
        bottom: 0;
        padding-bottom: 0.2rem;
        width: 100%;
        z-index: 10;
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: space-around;
        background: linear-gradient(180deg,hsla(0,0%,100%,0),#fff);
    }


    .van-tag {
        width: 55px;
        margin-left: 10px;
        text-align: center;
    }
    .between {
        justify-content: space-between;
    }


</style>
<script>
    import Vue from 'vue';
    import area from "../../../utils/area";
    import validator from "../../../utils/validator";
    import PicUploader from '@/components/picker/PicUploader.vue';
    import LoginDialog from "@/components/LoginDialog.vue";

    import {Cell,Field,Area,Form,Divider, CellGroup,RadioGroup,Radio,Icon, Toast, Popup, Picker, Sidebar, SidebarItem, Tag, Stepper ,Switch ,Button} from 'vant';

    Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
            .use(Switch).use(Button);
    export default {
        name: 'ClubApply',
        components: {
            PicUploader,LoginDialog
        },
        data: function () {
            return {
                validator,
                loginShow: false,
                saveLoading:false,
                showArea:false,
                areaList:{},
                areaValue:'',
                submitType:'',
                formData: {
                    id: 0,
                    areas:'',
                    province:'',
                    contactsqq:'',
                    qq:'',
                    city:'',
                    county:'',
                },
            }
        },
        filters: {},
        mounted() {
            document.title = "大课间";
            let that = this;
            that.areaList = area;
            that.formData.id = this.$route.query.id;
            this.getUserDetail();
//            if(that.formData.id){
//             this.fetch();
//            }
        },
        watch: {
            formData() {
            }
        },
        destroyed() {
        },
        methods: {
            getUserDetail() {
                let that = this;
                this.$api.get('/api/user/userPage', {}, (res) => {
                    console.log(res)
                },(res) =>{
                    if (res.code == 401 || res.code == 402) {
                        if (window.isApp()) {
                            rbLink(
                                {
                                    name: "login",
                                    query: {}
                                },
                                "replace"
                            );
                            return false;
                        } else {
                            // Toast(res.msg);
                            this.loginShow = true;
                        }
                    }else {
                        Toast(res.msg)
                    }
                })
            },
            loginSuccess(res) {
                console.log("-------登录成功--------", res);
                this.getUserDetail();
                this.loginShow = false;
            },

            loginCancel() {
                console.log("-------取消登录--------");
                // this.loginShow = false;
            },
            onQuestion(){
                console.log('onQuestion')
            },
            onAreaConfirm(values) {
                console.log(values);
                this.formData.area = values[2].code;
                this.formData.province = values[0].name;
                this.formData.city = values[1].name;
                this.formData.county = values[2].name;
                this.showArea = false;
            },
            onSubmit(values){
                console.log('onSubmit-values',values);
                console.log('submitType',this.submitType);

                let that = this;
                console.log(that.formData)
                that.formValidate = true;


                for (let field in that.formData) {

                    if (!this.formData.area) {
                        Toast('请选择地区');
                        return
                    }
                }
                that.saveLoading = true;

                that.$api.post('/api/cdakejian/apply', that.formData, (res) => {
                    that.saveLoading = false;
                    Toast('提交成功');
                    setTimeout(() =>{
                        rbLink({
                            name:"CDakejianApplySuccess",
                            query:{
                                id:res.data.id
                            }
                        },'replace')
                    },2000)
                }, (res) => {

                    if (res.code == 401 || res.code == 402) {
                        if (window.isApp()) {
                            rbLink(
                                {
                                    name: "login",
                                    query: {}
                                },
                                "replace"
                            );
                            return false;
                        } else {
                            // Toast(res.msg);
                            this.loginShow = true;
                        }
                    }
                    Toast(res.msg);
                    Toast.fail(res.msg);
                    that.saveLoading = false;
                })
            },
            save(values){
                this.submitType = 'save';
            },
            onFailed(errorInfo){
                console.log('failed', errorInfo);
            },
            submit(values) {
                this.submitType = 'submit';
            },

        }
    }
</script>



// WEBPACK FOOTER //
// DakejianApply.vue?84e4afd6